/**
 * Example to use component
 *       <CgRadioButton
         defaultValue="street_parking_available"
         options={[
           {
             code: "free_or_validated",
             name: "Free/Validated Parking",
           },
           {
             code: "paid_lot_available",
             name: "Paid Parking",
           },
           {
             code: "street_parking_available",
             name: "Street Parking Only",
           },
         ]}
         onSelect={() => {}}
         keyValues={{ label: "name", value: "code" }}
         customRenderLabel={() => {
           return (
             <div>
               <h1> Heading</h1>
               <p> Something can be added</p>
             </div>
           );
         }}
       />
 */

import React, { useEffect, useState } from "react";
import "./cgRadioButton.scss";

const CgRadioButton = ({
  name,
  options,
  onSelect,
  defaultValue,
  radioBtnLabel,
  resetValue,
  disabled = false, // disbale field
  keyValues = { label: "label", value: "value" },
  customRenderLabel = () => {}, // jsx function
  renderCustomError, // boolean value
  customErrorMsg, // string
}) => {
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    if (resetValue && !defaultValue) {
      setSelectedValue("");
    } else {
      setSelectedValue(defaultValue);
    }
  }, [resetValue]);

  useEffect(() => {
    if (defaultValue) {
      // setSelectedValue(defaultValue);
      setSelectedValue(selectedValue);
    }
  }, [defaultValue]);

  const handleChange = (value, metaData) => {
    setSelectedValue(value);
    onSelect(name, value, metaData);
  };

  const inputValue = () => {
    if (selectedValue) {
      if (isNaN(selectedValue)) {
        return selectedValue?.toLowerCase();
      } else {
        return selectedValue;
      }
    } else if (defaultValue) {
      if (isNaN(defaultValue)) {
        return defaultValue?.toLowerCase();
      } else {
        return defaultValue;
      }
    } else {
      return selectedValue;
    }
  };

  return (
    <div
      className={`radioButtonWrapper ${disabled ? "disable" : ""} ${
        renderCustomError ? "form-control error" : ""
      } `}
    >
      <div>
        <label> {radioBtnLabel ? radioBtnLabel : customRenderLabel()} </label>
      </div>
      <div className="radioBtnItem">
        {options.map((radioItem, index) => (
          <div className="form-check" key={index}>
            <input
              className="form-check-input"
              key={radioItem[keyValues.value]}
              type="radio"
              name={name}
              value={radioItem[keyValues.value]}
              checked={
                // "street parking only"
                inputValue() === radioItem[keyValues.value]
                // inputValue() === radioItem[keyValues.value].toLowerCase()
              }
              onChange={() =>
                handleChange(radioItem[keyValues.value], radioItem.metaData)
              }
            />
            <label
              className="form-check-label"
              onClick={() =>
                handleChange(radioItem[keyValues.value], radioItem.metaData)
              }
            >
              {radioItem[keyValues.label]}
            </label>
          </div>
        ))}
      </div>
      {customErrorMsg && (
        <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
      )}
    </div>
  );
};

export default CgRadioButton;
